import {axiosNodeClient} from '../http';

export const socialMediaServiceNode = {get, update}

//API public for web QR Social Media and Dashboard Admin
function get(storeId) {
    return axiosNodeClient.get(`/social-media/store/${storeId}`);
}

function update(data) {
    return axiosNodeClient.put(`/social-media/store/${data.store_id}`, data);
}
